import { User } from '@auth/user';
import { Avatar } from '@mui/material';
import { darken } from '@mui/material/styles';

function ProfileImage({ photo, user }: Readonly<{ photo: string, user: User }>) {

	if (photo && photo !== 'data:application/octet-stream;base64,') {
		return (
			<Avatar
				sx={(theme) => ({
					background: theme.palette.background.default,
					color: theme.palette.text.secondary,
					width: 35,
					height: 35
				})}
				className="avatar rounded-lg"
				alt="user photo"
				src={photo}
				variant="rounded"
			/>
		);
	}

	const split = user?.displayName?.split(' ') || [];
	const first = split[0] || '';


	return (
		<Avatar
			sx={(theme) => ({
				background: (theme) => darken(theme.palette.background.default, 0.05),
				color: theme.palette.text.secondary,
				width: 35,
				height: 35
			})}
			className="avatar md:mx-4 no-underline"
		>
			{first.charAt(0).toUpperCase()}
		</Avatar>
	);
}

export default ProfileImage;
